import type { JSX } from 'react';
import { Chip } from '@heroui/react';

import type { PatternSeverity } from '~/types';

const SEVERITY_CONFIG: Record<
  PatternSeverity,
  { color: 'danger' | 'primary' | 'default'; label: string }
> = {
  critical: { color: 'danger', label: 'Critical' },
  recommended: { color: 'primary', label: 'Recommended' },
  advisory: { color: 'default', label: 'Advisory' },
};

interface SeverityChipProps {
  severity: PatternSeverity;
  size?: 'sm' | 'md';
}

export function SeverityChip({ severity, size = 'sm' }: SeverityChipProps): JSX.Element {
  const config = SEVERITY_CONFIG[severity];
  return (
    <Chip color={config.color} size={size} variant="flat">
      {config.label}
    </Chip>
  );
}
